import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import { Lock } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import PageHeader from "../../../common/components/PageHeader";
import { toast } from "../../../common/components/Toast";
import { useProject } from "../../../common/contexts/ProjectContext";
import { deleteFile, getFile } from "../../api/files";

const DeleteData = () => {
  const { t } = useTranslation("sources");
  const { file_id } = useParams();
  const [file, setFile] = useState({});
  const navigate = useNavigate();

  // Get current user role from project context
  const { currentUserRole } = useProject();
  const isOwner = currentUserRole === "owner";

  useEffect(() => {
    const fetchFileData = async () => {
      try {
        const response = await getFile(file_id);
        setFile(response);
      } catch (error) {
        console.error("Error fetching files:", error);
        if (
          error.message.includes("403") ||
          error.message.includes("Only project owners")
        ) {
          toast.error(t("manualImport.accessDeniedOwners"));
          navigate("/sources/manual-import");
        }
      }
    };

    fetchFileData();
  }, [file_id, navigate, t]);

  const handleFileDeletion = async () => {
    try {
      await deleteFile(file_id);
      navigate("/sources/manual-import");
      toast.success(t("manualImport.fileDeletedSuccess"));
    } catch (error) {
      if (
        error.message.includes("403") ||
        error.message.includes("Only project owners")
      ) {
        toast.error(t("manualImport.accessDeniedDelete"));
      } else {
        toast.error(
          t("manualImport.fileDeleteError", { error: error.message }),
        );
      }
    }
  };

  // Show access denied message for non-owners
  if (!isOwner) {
    return (
      <div className="py-3">
        <PageHeader
          title={t("manualImport.deleteFile")}
          description={t("manualImport.deleteFileRestricted")}
        />

        <Alert severity="warning">
          <AlertTitle>{t("manualImport.accessRestricted")}</AlertTitle>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Lock size={20} />
            <Typography>{t("manualImport.deleteOnlyOwners")}</Typography>
          </Box>
        </Alert>
      </div>
    );
  }

  return (
    <div className="py-3">
      <PageHeader
        title={`Delete ${file.name}`}
        description={t("manualImport.deletingFile")}
      />

      <p>{t("manualImport.deleteFileWarning")}</p>

      <div className="d-flex mt-3">
        <div className="px-1">
          <button
            onClick={() => {
              handleFileDeletion();
            }}
            className="btn btn-danger fw-500"
          >
            {t("manualImport.confirmButton")}
          </button>
        </div>
        <div className="px-1">
          <button className="btn btn-basic fw-500">
            {t("manualImport.cancelButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteData;
